import { z } from 'zod';

export const CLIENT_LOG_LEVELS = ['warn', 'error'] as const;
export type ClientLogLevel = (typeof CLIENT_LOG_LEVELS)[number];

// Every field is capped: the endpoint writes straight into server logs, so one browser
// must not be able to push arbitrarily large lines.
export const ClientLogInputSchema = z.object({
  level: z.enum(CLIENT_LOG_LEVELS),
  // Where the error was bound, dotted: `<feature>.<screen>.<what>`, e.g. `ideas.submit.categories`.
  source: z
    .string()
    .trim()
    .min(1)
    .max(100)
    .regex(/^[a-z0-9][a-z0-9._-]*$/i),
  message: z.string().max(2_000),
  // HTTP status and API error code when the error came from an API call; absent for network/parse errors.
  status: z.number().int().optional(),
  code: z.string().max(100).optional(),
  // Error class name (`ApiError`, `TypeError`, `ZodError`, …): tells a blocked fetch from a bad response.
  errorName: z.string().max(100).optional(),
  stack: z.string().max(4_000).optional(),
  // Page the error happened on, without query string.
  path: z.string().max(500),
});
export type ClientLogInput = z.infer<typeof ClientLogInputSchema>;
